import { OutboundAppsClass } from './component/OutboundAppsClass';
import globals from '@descope-ui/theme-globals';

export const vars = OutboundAppsClass.cssVarList;

const outboundApps = {
  [vars.iconColor]: globals.colors.primary.main,
  [vars.errorIconColor]: globals.colors.error.main,

  [vars.appLogoGap]: globals.spacing.md,
  [vars.contentGap]: globals.spacing.xs,

  // list-item overrides
  [vars.itemCursor]: 'default',
  [vars.itemOutline]: 'none',
  [vars.itemBorderColor]: 'transparent',

  [vars.listPadding]: '0',
  [vars.listBorderWidth]: '0',
  [vars.listBoxShadow]: 'none',

  size: {
    xs: {
      [vars.fontSize]: '0.6em',
    },
    sm: {
      [vars.fontSize]: '0.8em',
    },
    md: {
      [vars.fontSize]: '1em',
    },
    lg: {
      [vars.fontSize]: '1.5em',
    },
  },
};

export default outboundApps;
